import $ from 'jquery'
import Radio from 'backbone.radio';

const globalChannel = Radio.channel('global');
const videoChapters = function($element) {
  var videoPlayerId = $element.data('video-player-id');

  $('.video-chapter', $element).on('click', function(e) {
    e.preventDefault(e);
    globalChannel.trigger("video_player:" + videoPlayerId + ":seek", $(this).data('seek'));
  });
};

// jQuery plugin method
$.fn.videoChapters = function(options) {
  this.each(function() {
    var $this = $(this);

    // If not already stored, store plugin object in this element's data
    if (!$this.data('videoChapters')) {
      $this.data('videoChapters', videoChapters($this, options));
    }
  });
};
